import { faCircleNotch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations } from 'use-intl';

/**
 * Bridges the gap between `isConversationOver` flipping true and recording
 * finalization actually starting. On hands-free that gap covers closing-TTS
 * playback (~3-6s); on chat mode it's the 2s trailing buffer. Without this
 * overlay the page looked frozen and users could close the tab.
 */
export default function ProjectUsabilityResponseWrappingUp() {
  const t = useTranslations('Usability');

  return (
    <div
      className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4'
      data-test='recording-wrapping-up-overlay'
    >
      <div className='flex w-full max-w-md flex-col items-center rounded-3xl bg-white px-5 py-6 text-center text-blue-950 shadow-2xl sm:px-8'>
        <FontAwesomeIcon icon={faCircleNotch} spin className='text-5xl' />
        <p className='mt-4 text-lg'>{t('wrappingUpTitle')}</p>
        <p className='mt-2 text-sm text-gray-600'>{t('wrappingUpBody')}</p>
      </div>
    </div>
  );
}
